import { SearchResult } from '#server/models';
import {
  ResultCard,
  ResultCardDescription,
  ResultCardHeader,
  ResultCardTitle,
  ResultCardLink,
  ResultCardTag,
  Badge,
  HighlightedText,
} from '@/components';
import { cn } from '@/utils';

export interface PDFResultCardProps {
  result: SearchResult;
}

export const PDFResultCard = ({ result }: PDFResultCardProps) => {
  const pdfDetails = result.pdfDetails!;
  return (
    <ResultCardLink to={pdfDetails.url ?? ''} result={result}>
      <ResultCard className={cn(result.forYou && 'border-highlight-border bg-highlight-bg')}>
        <ResultCardHeader>
          <ResultCardTag className="flex items-center">
            {result.forYou && <Badge className="mr-2 bg-ring text-white">For You</Badge>}
            <Badge variant={result.forYou ? 'forYou' : 'secondary'}>PDF</Badge>
            {pdfDetails.size && (
              <div
                className="relative ml-3 cursor-pointer pl-4 text-xs font-semibold underline underline-offset-2 before:absolute before:left-0
                  before:top-1/2 before:h-1 before:w-1 before:-translate-y-1/2 before:rounded-full before:bg-gray-500 before:content-['']"
              >
                {pdfDetails.size}
              </div>
            )}
          </ResultCardTag>
          <ResultCardTitle>
            <span className="break-all">{decodeURIComponent(pdfDetails.title)}</span>
          </ResultCardTitle>
          <ResultCardDescription>
            <HighlightedText text={pdfDetails.description} />
          </ResultCardDescription>
        </ResultCardHeader>
      </ResultCard>
    </ResultCardLink>
  );
};
